/** Cards fetched per lane, per group leaf, and per "show more" page. */
export const TASKS_DASHBOARD_PAGE_SIZE = 20;

/** Group headers fetched per page. */
export const TASKS_DASHBOARD_GROUP_PAGE_SIZE = 20;

/**
 * Rows fetched per Gantt group, matching the chart's own `DEFAULT_TASK_LIMIT` — the number it reveals
 * before offering "Show more". Kept equal deliberately: a page larger than the reveal step arrives
 * partly hidden, so one click loads rows and another is needed to see them, and the two buttons count
 * down in different sizes. Equal, there is one button and every click adds the same 20 rows.
 *
 * It coincides with `TASKS_DASHBOARD_PAGE_SIZE` at present, but is its own constant because it is
 * tied to the chart's reveal step rather than to the lanes': raising one of those must not silently
 * break the other.
 */
export const TASKS_DASHBOARD_GANTT_PAGE_SIZE = 20;
